/* eslint-disable */
// Neutral home for the action-type string constants that commons.reducer.js
// consumes from V1 page modules removed during the V2 promotion (FEAT-002).
// Each value is copied byte-for-byte from the original module's reducer so the
// global `app` reducer keeps merging on the exact same action-type strings.

// modules/main/ViewReport/reducer/viewReport.reducer.js (PATH = 'viewReport')
export const VIEW_REPORT = {
  GET_SATE_FROM_API_SUCCESS: 'viewReport/GET_SATE_FROM_API_SUCCESS',
};

// modules/main/SellersManager/reducer/sellersManager.reducer.js (PATH = 'sellersManager/')
// Note: the original SELLERS_MANAGER object never defined INITIAL_QUERY_SUCCESS,
// so commons.reducer's SELLERS_MANAGER.INITIAL_QUERY_SUCCESS resolved to undefined;
// preserved here verbatim to keep the global `app` reducer's merge set identical.
export const SELLERS_MANAGER = {
  INITIAL_QUERY_SUCCESS: undefined,
  CREATE_SELLER_SUCCESS: 'sellersManager/CREATE_SELLER_SUCCESS',
  DELETE_SELLER_SUCCESS: 'sellersManager/DELETE_SELLER_SUCCESS',
};

// modules/main/EditUser/reducer/editUser.reducer.js (PATH = 'editUser/')
export const EDIT_USER = {
  INITIAL_QUERY_SUCCESS: 'editUser/INITIAL_QUERY_SUCCESS',
};

// modules/main/LotCategories/reducer/lotCategories.reducer.js (PATH = 'lotCategories/')
export const LOT_CATEGORIES = {
  INITIAL_QUERY_SUCCESS: 'lotCategories/INITIAL_QUERY_SUCCESS',
  CREATE_LOT_CATEGORY_SUCCESS: 'lotCategories/CREATE_LOT_CATEGORY_SUCCESS',
  EDIT_LOT_CATEGORY_SUCCESS: 'lotCategories/EDIT_LOT_CATEGORY_SUCCESS',
  DELETE_LOT_CATEGORY_SUCCESS: 'lotCategories/DELETE_LOT_CATEGORY_SUCCESS',
};

// modules/main/AuctionCategories/reducer/auctionCategories.reducer.js (PATH = 'auctionCategories/')
export const AUCTION_CATEGORIES = {
  INITIAL_QUERY_SUCCESS: 'auctionCategories/INITIAL_QUERY_SUCCESS',
  CREATE_AUCTION_CATEGORY_SUCCESS: 'auctionCategories/CREATE_AUCTION_CATEGORY_SUCCESS',
  EDIT_AUCTION_CATEGORY_SUCCESS: 'auctionCategories/EDIT_AUCTION_CATEGORY_SUCCESS',
  DELETE_AUCTION_CATEGORY_SUCCESS: 'auctionCategories/DELETE_AUCTION_CATEGORY_SUCCESS',
};

// modules/main/EntitledLots/reducer/entitledLots.reducer.js (PATH = 'orderLots/')
// Byte-identical to modules/main/SortLots/reducer/sortLots.reducer.js (same PATH),
// which remains the surviving owner of the orderLots slice.
export const ORDER_LOTS = {
  INITIAL_QUERY_SUCCESS: 'orderLots/INITIAL_QUERY_SUCCESS',
  GET_AUCTION_LOTS_FROM_API_SUCCESS: 'orderLots/GET_AUCTION_LOTS_FROM_API_SUCCESS',
  CREATE_LOTS_WITH_RIGHTS_SUCCESS: 'orderLots/CREATE_LOTS_WITH_RIGHTS_SUCCESS',
};

// modules/main/LotsManager/reducer/lotsManager.reducer.js (PATH = 'lotsManager/')
export const LOTS_MANAGER = {
  UPLOAD_LOT_DOCUMENT_SUCCESS: 'lotsManager/UPLOAD_LOT_DOCUMENT_SUCCESS',
  INITIAL_QUERY_SUCCESS: 'lotsManager/INITIAL_QUERY_SUCCESS',
  GET_BASIC_INFO_SUCCESS: 'lotsManager/GET_BASIC_INFO_SUCCESS',
  GET_HISTORY_SUCCESS: 'lotsManager/GET_HISTORY_SUCCESS',
  DESTROY_LOT_DOCUMENT_SUCCESS: 'lotsManager/DESTROY_LOT_DOCUMENT_SUCCESS',
  EDIT_LOT_SUCCESS: 'lotsManager/EDIT_LOT_SUCCESS',
};

// modules/main/Users/reducer/users.reducer.js (PATH = 'users/')
export const USERS = {
  INITIAL_QUERY_SUCCESS: 'users/INITIAL_QUERY_SUCCESS',
  ROLE_ASSIGMENT_SUCCESS: 'users/ROLE_ASSIGMENT_SUCCESS',
  SAVE_SELLER_SUCCESS: 'users/SAVE_SELLER_SUCCESS',
  HANDLE_ENABLE_USER_SUCCESS: 'users/HANDLE_ENABLE_USER_SUCCESS',
  GET_USER_ADJUDICATIONS_SUCCESS: 'users/GET_USER_ADJUDICATIONS_SUCCESS',
};

// modules/main/GuaranteesAndPayments/reducer/newGuarantee.reducer.js (PATH = 'guaranteesUnification/')
export const GUARANTEES_UNIFICATION = {
  INITIAL_QUERY_SUCCESS: 'guaranteesUnification/INITIAL_QUERY_SUCCESS',
  REJECT_RECEIPT_SUCCESS: 'guaranteesUnification/REJECT_RECEIPT_SUCCESS',
  ACKNOWLEDGE_REFUND_SUCCESS: 'guaranteesUnification/ACKNOWLEDGE_REFUND_SUCCESS',
  EDIT_AMOUNT_SUCCESS: 'guaranteesUnification/EDIT_AMOUNT_SUCCESS',
  ACCEPT_RECEIPT_SUCCESS: 'guaranteesUnification/ACCEPT_RECEIPT_SUCCESS',
  CHANGE_AMOUNT_SUCCESS: 'guaranteesUnification/CHANGE_AMOUNT_SUCCESS',
  UNSET_FLAG_SUCCESS: 'guaranteesUnification/UNSET_FLAG_SUCCESS',
  SET_FLAG_SUCCESS: 'guaranteesUnification/SET_FLAG_SUCCESS',
  RETRY_PAYMENT_SUCCESS: 'guaranteesUnification/RETRY_PAYMENT_SUCCESS',
  UNDO_PAYMENT_SUCCESS: 'guaranteesUnification/UNDO_PAYMENT_SUCCESS',
  ENABLE_PAYMENT_SUCCESS: 'guaranteesUnification/ENABLE_PAYMENT_SUCCESS',
  DISABLE_PAYMENT_SUCCESS: 'guaranteesUnification/DISABLE_PAYMENT_SUCCESS',
  REJECT_PAYMENT_SUCCESS: 'guaranteesUnification/REJECT_PAYMENT_SUCCESS',
};

// modules/main/GuaranteesAndPayments/reducer/newPayment.reducer.js (PATH = 'paymentsUnification/')
export const PAYMENTS_UNIFICATION = {
  INITIAL_QUERY_SUCCESS: 'paymentsUnification/INITIAL_QUERY_SUCCESS',
};

// modules/main/UserProfile/reducer/userProfile.reducer.js (PATH = 'userProfile/')
// UserProfile V1 (/profile_legacy) fue eliminado al promover MyProfile_v2 como
// "Mi perfil" canónico. commons.reducer solo consume estos dos success-types.
export const USER_PROFILE = {
  INITIAL_QUERY_SUCCESS: 'userProfile/INITIAL_QUERY_SUCCESS',
  SUBMIT_FORM_SUCCESS: 'userProfile/SUBMIT_FORM_SUCCESS',
};
